import TextArea from './TextArea';
import { TextAreaProps, TextAreaValueProps } from './types';

export type { TextAreaProps, TextAreaValueProps };
export default TextArea;
